import { APPOINTMENT_SUMMARY } from '../../constants/dashboard';
import { summaryColumns } from '../../constants/tableColumns';
import DashboardSectionLayout from '../../layouts/DashboardSectionLayout';
import AcademiaDashboardTable from '../CommonComps/Tables/AcademiaDashboardTable';

const AppointmentSummary = () => {
  // rendering appointment summary section component here
  return (
    <DashboardSectionLayout sectionTitle='Appointment Summary'>
      <AcademiaDashboardTable
        data={APPOINTMENT_SUMMARY}
        columns={summaryColumns}
        showPagination
      />
    </DashboardSectionLayout>
  );
};

export default AppointmentSummary;
